<span
  class="iu-checkbox"
  [ngClass]="{
    'iu-checkbox-disabled': disabled,
    'iu-checkbox-tri': tristate,
  }"
  (click)="onClick($event)">
  @if (tristate) {
    <ng-container [ngTemplateOutlet]="tristateTpl" />
  } @else {
    <ng-container [ngTemplateOutlet]="bistateTpl" />
  }
</span>

<ng-template #tristateTpl>
  <i
    aria-hidden="true"
    tabindex="0"
    [ngClass]="{
      'icon-checkbox-checked': checked === true,
      'icon-checkbox-tri-false': checked === false,
      'icon-checkbox-unchecked': checked === null,
    }"></i>
</ng-template>

<ng-template #bistateTpl>
  <i
    aria-hidden="true"
    tabindex="0"
    [ngClass]="{
      'icon-checkbox-checked': checked,
      'icon-checkbox-unchecked': !checked,
    }"></i>
</ng-template>
